import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router';
import { useMount } from 'react-use';

import { useForm, useFormTerms } from '@app/features/form';
import { isAuthenticated } from '@app/store/account/selectors';

export default function useCheckFormAgreement(formId: string | null) {
  const location = useLocation();
  const history = useHistory();

  const isAuth = useSelector(isAuthenticated);

  useMount(() => {
    if (!isAuth) {
      history.replace(`/form-agreement${location.search}`);
    }
  });

  const formAgreementData = useFormTerms({
    onSuccess: (data) => {
      if (!data.formUseAgreed) {
        history.replace(`/form-agreement${location.search}`);
      }
    },
    enabled: !!formId && isAuth,
    refetchOnMount: false,
  });

  const formData = useForm(formId, { enabled: formAgreementData.isSuccess });

  return {
    form: formData.data,
    isLoading: formAgreementData.isLoading || formData.isLoading,
    isSuccess: formAgreementData.isSuccess && formData.isSuccess,
    error: formAgreementData.error || formData.error,
    refetch: () => {
      formAgreementData.refetch();
      formData.refetch();
    },
  };
}
